import { z } from 'zod'

import { PaymentProvider } from '../constants/pricing'

export const transactionSchema = z.object({
  id: z.string(),
  user: z.string().optional(),
  prospect: z.string().optional(),
  booking: z.string().optional(),
  paymentProfile: z.string().optional(),
  charge: z.number().optional(),
  currencyCode: z.string().optional(),
  credit: z.number().optional(),
  voided: z.boolean().optional(),
  refunded: z.boolean().optional(),
  refundDetails: z
    .object({
      id: z.string().optional(),
      amount: z.number().optional(),
    })
    .optional(),
  settled: z.boolean().optional(),
  settledAmount: z.number().optional(),
  providerType: z.nativeEnum(PaymentProvider).optional(),
  providerChargeId: z.string().optional(),
  providerAccountId: z.string().optional(),
  providerSettlementCurrencyCode: z.string().nullish(),
  providerExchangeRate: z.number().nullish(),
  providerChargeUsd: z.number().nullish(),
  providerProcessingFee: z.number().optional(),
  providerProcessingFeeUsd: z.number().nullish(),
  providerApplicationFee: z.number().optional(),
  providerApplicationFeeUsd: z.number().nullish(),
  descriptor: z.string().optional(),
})

export const transactionCreateArgsSchema = z
  .object({
    userId: z.string().optional(),
    prospectId: z.string().optional(),
    bookingId: z.string(),
    charge: z.number().min(0),
    paymentProfileId: z.string(),
    metadata: z.record(z.string(), z.unknown()).optional(),
    descriptor: z.string().optional(),
    currencyCode: z.string().optional(),
    providerChargeId: z.string().optional(),
    credit: z.number().optional(),
    applicationFeeAmount: z.number().optional(),
  })
  .refine((data) => Boolean(data.userId || data.prospectId), {
    message: 'userId or prospectId is required',
  })

export const transactionCancelByIdArgsSchema = z.object({
  id: z.string(),
})

export const transactionRefundByIdArgsSchema = z.object({
  id: z.string(),
})

export const transactionRefundAmountByIdArgsSchema = z.object({
  id: z.string(),
  amount: z.number().nullable(),
})

export const transactionCreatedEventPayloadSchema = z.object({
  transactionId: z.string().nullable(),
  options: transactionCreateArgsSchema.optional(),
})

export const transactionCreateFailedEventPayloadSchema = z.object({
  transactionId: z.null(),
  options: transactionCreateArgsSchema,
})
